import { toCSSPixel } from '../../utils/styles'

import { BOTTOM_HEIGHT } from './Dropdown.constants'

function isBottomPosition(rect, maxHeight, isDropdownBottomPosition) {
  if (!maxHeight || isDropdownBottomPosition) {
    return true
  }

  return window.innerHeight - rect.bottom > maxHeight
}

function getBottomPositionStyle(rect) {
  return { top: toCSSPixel(rect.top + rect.height) }
}

function getTopPositionStyle(rect, maxHeight) {
  return { top: toCSSPixel(rect.top - maxHeight - BOTTOM_HEIGHT) }
}

function getHorizontalPosition(rect, maxWidth) {
  return {
    left: toCSSPixel(rect.left),
    width: maxWidth || toCSSPixel(rect.width),
  }
}

function getVerticalPosition(rect, maxHeight, isDropdownBottomPosition) {
  return isBottomPosition(rect, maxHeight, isDropdownBottomPosition)
    ? getBottomPositionStyle(rect)
    : getTopPositionStyle(rect, maxHeight)
}

export function getDropdownStyle(
  rect,
  maxHeight,
  maxWidth,
  isDropdownBottomPosition
) {
  return {
    ...getHorizontalPosition(rect, maxWidth),
    ...getVerticalPosition(rect, maxHeight, isDropdownBottomPosition),
  }
}
